import { ICONS_MAPPING } from '@components/icons/constants';
import { SvgWrapperProps, IconProps } from '@components/icons/types';

function SvgWrapper({ children, size = 24, altText = '', color = 'currentColor', className }: SvgWrapperProps) {
  return (
    <svg
      style={{ minWidth: `${size}px` }}
      width={size}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      color={color}
      role="img"
      aria-label={altText}
      className={className}
    >
      {children}
    </svg>
  );
}

function Icon({ icon, size = 24, altText, color = 'currentColor', className = '' }: IconProps) {
  return (
    <SvgWrapper color={color} size={size} altText={altText} className={className}>
      {ICONS_MAPPING[icon]}
    </SvgWrapper>
  );
}

export default Icon;
